export default __webpack_public_path__ + "static/media/stock-photo-raw-unpeeled-potatoes-removebg-preview.0707a7fd.png";